// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer[data-v-67bcd1fe]{width:100%}footer .container[data-v-67bcd1fe]{margin-bottom:0}.copyright li[data-v-67bcd1fe]:first-child{text-transform:none!important}footer a[data-v-67bcd1fe]{color:#55585c;cursor:pointer}", ""]);
// Exports
module.exports = exports;
